import React from 'react'

class SignUp extends React.Component {
    render() {
        return (
            <div> Sign Up page</div>
        )
    }
}

export default SignUp


// WEBPACK FOOTER //
// ./src/Components/SignUp.js